import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQueries, useQueryClient } from '@tanstack/react-query';
import getFetchProductContentOptions from './get-options';
var useFetchProductContent = function useFetchProductContent(_ref) {
  var products = _ref.products,
    select = _ref.select;
  var queryClient = useQueryClient();
  return useQueries({
    queries: products.map(function (_ref2) {
      var productId = _ref2.productId,
        styleColor = _ref2.styleColor,
        fetchVasContent = _ref2.fetchVasContent;
      return _objectSpread(_objectSpread(_objectSpread({}, getFetchProductContentOptions({
        queryClient: queryClient,
        productId: productId,
        styleColor: styleColor,
        fetchVasContent: fetchVasContent
      })), select && {
        select: select
      }), {}, {
        enabled: Boolean(productId || styleColor)
      });
    })
  });
};
export default useFetchProductContent;